module.exports = __webpack_public_path__ + "static/Map_Image-0197f9584773dcf6933ddc12ac5522db.png";